import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { Vehicle } from '@sm360/widget-commons-vehicle';

import SpecificationLine from './SpecificationLine.jsx';

const { VehicleModelV25 } = Vehicle;

const Specification = ({ vehicle }) => {
    const colorItem = (
        <SpecificationLine
            key={`color-${vehicle.exteriorColor.code}`}
            description={vehicle.exteriorColor.colorDescription}
        />
    );

    const packageItem = vehicle.purchaseMethods.packageDescription !== '' && (
        <SpecificationLine
            key={`package-${vehicle.purchaseMethods.packageDescription}`}
            description={vehicle.purchaseMethods.packageDescription}
        />
    );

    const otherOptions = vehicle.purchaseMethods.getAdditionalVehicleOptions();
    const optionsCountString =
        otherOptions.length > 1
            ? LocaleService.t('SUMMARY.OPTION_COUNT_PLURAL', { count: otherOptions.length })
            : LocaleService.t('SUMMARY.OPTION_COUNT_SINGLE');
    const optionItems = !!otherOptions.length && <SpecificationLine key="options" description={optionsCountString} />;

    return (
        <div className="listing-tile-specification-wrapper">
            <p className="listing-tile-package-head is-bold is-uppercase is-price sr-disclaimer">
                {LocaleService.t('SUMMARY.OPTION_HEADER')}
            </p>
            {packageItem}
            {optionItems}
            {colorItem}
        </div>
    );
};

Specification.propTypes = {
    vehicle: PropTypes.instanceOf(VehicleModelV25).isRequired,
};

Specification.displayName = 'NewTile.Specification';

export default Specification;
